import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 48px;\n  border: 0;\n  border-radius: 4px;\n  padding: 0 12px;\n  background-color: rgba(255, 255, 255, 1);\n  backdrop-filter: blur(2px);\n  color: rgb(5, 0, 56);\n  font-family: Formular, Helvetica, Arial, serif;\n  font-size: 20px;\n  cursor: pointer;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  margin-left: 10px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  top: 8px;\n  left: 8px;\n  z-index: 1000;\n  opacity: ",
        ";\n  transition: opacity 0.1s linear;\n  pointer-events: ",
        ";\n\n  &:hover {\n    ",
        " {\n      color: #3f53d9;\n    }\n\n    svg path {\n      fill: #3f53d9;\n    }\n  }\n\n  &:focus-visible {\n    box-shadow: inset 0 0 0 2 #3f53d9;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
import { IconArrow } from "./icons/Icons";
var Button = styled.button.withConfig({
    componentId: "sc-6b5b0112-0"
})(_templateObject());
var ButtonText = styled.span.withConfig({
    componentId: "sc-6b5b0112-1"
})(_templateObject1());
var BackButtonContainer = styled.span.withConfig({
    componentId: "sc-6b5b0112-2"
})(_templateObject2(), function(param) {
    var isVisible = param.isVisible;
    return isVisible ? 1 : 0;
}, function(param) {
    var isVisible = param.isVisible;
    return isVisible ? "auto" : "none";
}, Button);
export var BackButton = function(param) {
    var isVisible = param.isVisible, onClick = param.onClick;
    return /*#__PURE__*/ _jsx(BackButtonContainer, {
        onClick: onClick,
        isVisible: isVisible,
        children: /*#__PURE__*/ _jsxs(Button, {
            children: [
                /*#__PURE__*/ _jsx(IconArrow, {}),
                /*#__PURE__*/ _jsx(ButtonText, {
                    children: "Go back"
                })
            ]
        })
    });
};
